export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openEventForm({commit}) {
        commit('setFormOpen');
    },
    closeEventForm({commit}) {
        commit('setFormClose');
    },
    openDetailForm({commit}) {
        commit('setDetailFormOpen');
    },
    openDetailGrid({commit}) {
        commit('setDetailGridOpen');
    }
}
